import { render, staticRenderFns } from "./BaseRent.vue?vue&type=template&id=4020a5fb&scoped=true"
import script from "./BaseRent.vue?vue&type=script&lang=js"
export * from "./BaseRent.vue?vue&type=script&lang=js"
import style0 from "./BaseRent.vue?vue&type=style&index=0&id=4020a5fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4020a5fb",
  null
  
)

export default component.exports